import {priceRule, PriceRule} from "./price/PriceRuleComponent";
import {adxRule, AdxRule} from "./adx/AdxRuleComponent";

export default function(parentDir: string): string {
    const rootDir = `${parentDir}/rules`;

    return angular.module("tfApp.trading-alerts.alert-dialog.rules", [])
                  .component(PriceRule, priceRule(rootDir))
                  .component(AdxRule, adxRule(rootDir))
                  .name;
}
